import {
  MARK_SOFTSKILLS_NOTIFICATION,
  MARK_SOFTSKILLS_NOTIFICATION_SUCCESS,
  MARK_SOFTSKILLS_NOTIFICATION_CLEAN,
  MARK_SOFTSKILLS_NOTIFICATION_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  notification: undefined,
}

const SoftskillsNotificationsMark = (state = initialState, action) => {
  switch (action.type) {
    case MARK_SOFTSKILLS_NOTIFICATION:
      state = {
        ...state,
        loading: true,
      }
      break
    case MARK_SOFTSKILLS_NOTIFICATION_SUCCESS:
      state = {
        ...state,
        notification: action.payload.notification,
        loading: false,
        done: true,
      }
      break
    case MARK_SOFTSKILLS_NOTIFICATION_CLEAN:
      state = initialState
      break
    case MARK_SOFTSKILLS_NOTIFICATION_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default SoftskillsNotificationsMark
